module.exports = __webpack_public_path__ + "fonts/AvenirBold.822741b.ttf";